import Home from '@/components/frame/Home'

const home = {
  isShow: true,
  index: 10,
  path: '/analysis',
  component: Home,
  redirect: '/analysis/analysisAll/scaleStatistical',
  name: 'Analysis',
  isHead: true,
  meta: {
    title: '统计分析',
    icon: 'el-icon-data-analysis'
  },
  children: [
    {
      path: 'analysisAll',
      component: () => import('@/views/analysis/index'),
      name: 'AnalysisAll',
      meta: { title: '统计分析', close: false },
      children: [
        {
          path: 'scaleStatistical',
          component: () => import('@/views/analysis/scaleStatistical/index'),
          name: 'scaleStatistical',
          meta: { title: '企业规模统计', next: '/analysis/analysisAll/companyCollection', close: false}
        },
        {
          path: 'companyCollection',
          component: () => import('@/views/analysis/companyCollection/index'),
          name: 'companyCollection',
          meta: { title: '单位信息采集率统计', next: '/analysis/analysisAll/informationCollection', close: false}
        },
        {
          path: 'informationCollection',
          component: () => import('@/views/analysis/informationCollection/index'),
          name: 'informationCollection',
          meta: { title: '计划和实际填报单位数对比统计表', next: '/analysis/analysisAll/userLoginStatistical', close: false}
        },
        {
          path: 'userLoginStatistical',
          component: () => import('@/views/analysis/userLoginStatistical/index'),
          name: 'userLoginStatistical',
          meta: { title: '企业端用户登录情况统计表', next: '/analysis/analysisAll/superviseLoginStatistical', close: false}
        },
        {
          path: 'superviseLoginStatistical',
          component: () => import('@/views/analysis/superviseLoginStatistical/index'),
          name: 'superviseLoginStatistical',
          meta: { title: '监管端用户登录情况统计表', next: '/analysis/analysisAll/threeList', close: false}
        },
        {
          path: 'threeList',
          name: 'threeList',
          component: () => import('@/views/analysis/threeList/index'),
          meta: {title: '企业三张清单进度表', next: '/analysis/analysisAll/dynamicMonitoring', close: true}
        }, {
          path: 'dynamicMonitoring',
          name: 'dynamicMonitoring',
          component: () => import('@/views/analysis/dynamicMonitoring/index'),
          meta: {title: '安全风险动态监督', next: '/analysis/analysisAll/promotion', close: true}
        }, {
          path: 'promotion',
          name: 'promotion',
          component: () => import('@/views/analysis/promotion/index'),
          meta: {title: '安全生产标准化达标', next: '/analysis/analysisAll/accident', close: true}
        }, {
          path: 'accident',
          name: 'accident',
          component: () => import('@/views/analysis/accident/index'),
          meta: { title: '安全生产事故统计', next: '/analysis/analysisAll/reviewInfo', close: true }
        }, {
          path: 'reviewInfo',
          name: 'reviewInfo',
          component: () => import('@/views/reviewInfo/index'),
          meta: { title: '复核信息查询', close: true }
        }
      ]
    }
  ]
}

export default home



// WEBPACK FOOTER //
// ./src/router/modules/analysis.js